import axios from 'smg/axios';
import * as models from 'smg/customer-api/models';
import * as paymentmethods from 'smg/customer-api/paymentoptions';
import * as session from 'smg/customer-api/session';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { AccountReady } from '../account-session';
import { PageLoader } from '../account';
import { DrawPaymentOption, PromptNewPaymentOption } from '../payments';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const cardTemplate = document.querySelector('#card') as HTMLTemplateElement;
    const parent = document.querySelector('#paymentMethodsContainer') as HTMLElement;
    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const addNewButton = document.querySelectorAll('.addNew');

    let user: models.User;

    const pl: PageLoader<models.HyejooPaymentOption> = new PageLoader<models.HyejooPaymentOption>({
        afterLoad: state => {
            if (state === 'failed') {
                return;
            }
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        init: async () => {
            user = await session.Session().then(s => s.user);
            addNewButton.forEach(el => {
                el.addEventListener('click', () => {
                    void PromptNewPaymentOption(user, 'Save', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT]).then(() => {
                        pl.load();
                    });
                });
            });
        },
        parent: document.querySelector('#paymentMethodsContainer') as HTMLElement,
        get: () => axios.get('/payment-options', {
            params: {
                'sort': pl.sort(),
                'max': pl.currentPageSize(),
                'data': 'id,address,creditCardFirst6,creditCardLast4,creditCardExpirationDate,paymentOptionTypeID',
                'p': pl.currentPage(),
                'q': pl.search() + 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip valid:yes',
            },
        }).then(resp => {
            const data = models.PaymentOptionsHyejooResponse.fromJSON(resp.data);
            return { rows: data.paymentOptions, nextPage: data.nextPage };
        }),
        draw: async paymentOption => {
            const card = template.Clone(cardTemplate).firstElementChild as HTMLElement;
            const deleteBtn = card.querySelector<HTMLButtonElement>('.delete-btn');
            const editBtn = card.querySelector<HTMLButtonElement>('.edit-btn');

            await DrawPaymentOption(paymentOption, undefined, card);

            // Checkout drops options whose stored phone fails the server tel validator; let the customer fix it here.
            if (!phone.IsValid(paymentOption.address.phoneNumber?.phone)) {
                card.querySelector<HTMLElement>('.card-body')?.appendChild(phone.InvalidPhoneNote());
            }

            editBtn?.addEventListener('click', () => {
                void PromptNewPaymentOption(user, 'Update', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT], paymentOption).then(() => {
                    pl.load();
                });
            });

            deleteBtn?.addEventListener('click', () => {
                void paymentmethods.DeletePaymentOption(paymentOption.id).
                    then(() => {
                        card.parentElement?.removeChild(card);
                        toast.Undo('Removed payment method.', async () => {
                            await paymentmethods.RestorePaymentOption(paymentOption.id);
                            pl.load();
                        });
                        pl.load();
                    });
            });

            return card;
        },

    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.load();
}
